import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { PublishCheck } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/publish-check")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <PublishCheck />
    </RouteGuard>
  ),
});
